import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=a278c0a6&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=a278c0a6&scoped=true&lang=stylus&"
import style1 from "./newsList.vue?vue&type=style&index=1&id=a278c0a6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a278c0a6",
  null
  
)

export default component.exports